import { getAuthenticatedClient } from './client';
import type * as IAPI from './interfaces/location';

export const getAzureMapsToken = (): Promise<IAPI.GetAzureMapsToken.Response> => {
  return getAuthenticatedClient().post<IAPI.GetAzureMapsToken.Response>('/location/azure-maps-token').then(res => res.data);
};